import "./footer.css";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { useState } from "react";
// Footer logo now uses PNG from public/images


function Footer() {
  const { t } = useTranslation('common');
  const [email, setEmail] = useState('');
  const [signupState, setSignupState] = useState('idle');
  const signupUrl = process.env.REACT_APP_NEWSLETTER_SUBSCRIBE_URL;

  async function handleSubscribe(event) {
    event.preventDefault();
    if (!event.currentTarget.reportValidity()) return;
    if (!signupUrl) {
      setSignupState('unavailable');
      return;
    }

    setSignupState('loading');
    try {
      const response = await fetch(signupUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), source: 'marketplace-footer' }),
      });
      if (!response.ok) throw new Error('Subscription failed');
      setEmail('');
      setSignupState('success');
    } catch {
      setSignupState('error');
    }
  }
  const navLinks = [
    { label: t('nav.home', 'Home'), to: '/' },
    { label: t('nav.allProjects', 'All projects'), to: '/explore' },
    { label: t('nav.about', 'About us'), to: 'https://innovacrypto.com.br', external: true },
  ];

  return (
    <div className="footer">
      <div className="footer-inner">
        <div className="footer-cta-grid">
          <section className="footer-cta-card footer-updates-card">
            <p className="footer-cta-eyebrow">{t('footer.updatesEyebrow')}</p>
            <h2>{t('footer.updatesTitle')}</h2>
            <p>{t('footer.updatesBody')}</p>
            <form className="footer-subscribe-form" onSubmit={handleSubscribe}>
              <label className="footer-visually-hidden" htmlFor="footer-subscribe-email">{t('footer.updatesEmail')}</label>
              <input id="footer-subscribe-email" type="email" required autoComplete="email" placeholder={t('footer.updatesPlaceholder')} value={email} onChange={(event) => { setEmail(event.target.value); setSignupState('idle'); }} />
              <button type="submit" disabled={signupState === 'loading'}>{signupState === 'loading' ? t('footer.updatesLoading') : t('footer.updatesAction')} <span aria-hidden="true">→</span></button>
            </form>
            <p className="footer-consent">{t('footer.updatesConsent')}</p>
            <p className="footer-signup-status" role="status" aria-live="polite">
              {signupState === 'success' && t('footer.updatesSuccess')}
              {signupState === 'error' && t('footer.updatesError')}
              {signupState === 'unavailable' && t('footer.updatesUnavailable')}
            </p>
          </section>
        </div>
        <div className="footer-top">
          <div className="footer-logo" aria-label={t('footer.logoAria', 'Innova Marketplace')} role="img">
            <img src={process.env.PUBLIC_URL + '/images/Innova Crypto logo light.png'} alt={t('footer.logoAlt', 'Innova Marketplace')} style={{ height:80, objectFit:'contain', display:'block' }} />
          </div>
          <nav className="footer-nav">
            {navLinks.map((link) =>
              link.external ? (
                <a
                  key={link.to}
                  href={link.to}
                  className="footer-nav-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.label}
                </a>
              ) : (
                <Link key={link.to} to={link.to} className="footer-nav-link">
                  {link.label}
                </Link>
              )
            )}
          </nav>
        </div>
        <div className="footer-divider" />
        <div className="footer-bottom">
          <p className="footer-powered">
            {t('footer.poweredBy', 'Powered by')} <span className="footer-neuro">{t('footer.neuro', 'Neuro')}</span>
          </p>
        </div>
      </div>
      
    </div>
  );
}

export default Footer;
